var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'nuxt-class-component';
import Utils from '~/services/Utils';
var Rules = (function (_super) {
    __extends(Rules, _super);
    function Rules() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.serverErrors = [];
        return _this;
    }
    Rules.prototype.required = function (v) {
        return !!v || this.$t('form.rules.required');
    };
    Rules.prototype.emailRules = function (v) {
        return /^\w+([\.\-\+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(v) || this.$t('form.rules.email');
    };
    Rules.prototype.phoneRules = function (v) {
        return /^\d{7,}$/.test(v) || this.$t('form.rules.phone');
    };
    Rules.prototype.server = function (field) {
        var _this = this;
        return function (v) {
            var error = _this.serverErrors ?
                _this.serverErrors.find(function (error) { return error.field === field; }) : null;
            if (!error)
                return true;
            return _this.$root.$t("errors['" + error.message + "']");
        };
    };
    Rules.prototype.scrollToError = function () {
        this.$nextTick(function () {
            var field = document.getElementById('addForm').querySelector('.error--text');
            if (field) {
                var position = Utils.getTopPosition(field);
                if (position) {
                    position -= 70;
                    Utils.pageScrollUp(position);
                }
            }
        });
    };
    Rules.prototype.registerServerErrors = function (serverErrors) {
        this.serverErrors = serverErrors;
    };
    Rules.prototype.registerServerError = function (serverError) {
        this.serverErrors.push(serverError);
    };
    Rules.prototype.unregisterServerError = function (field) {
        var index = this.serverErrors ?
            this.serverErrors.findIndex(function (error) { return error.field === field; }) : null;
        if (this.serverErrors && ~index) {
            this.serverErrors.splice(index, 1);
        }
    };
    Rules = __decorate([
        Component
    ], Rules);
    return Rules;
}(Vue));
export default Rules;



//////////////////
// WEBPACK FOOTER
// ./mixins/rules.ts
// module id = ./mixins/rules.ts
// module chunks = 2 4 5 6 7 8 12 13 16